import type RegistrationService from 'shared/login/registration.service';
import type {Auth} from 'typings/portaro.be.types';
import type UserService from '../../features/user/user.service';

export default class UserActivationRequiredDialogController {
    public static readonly controllerName = 'UserActivationRequiredDialogCtrl';

    private closeDialogFunction: () => any;

    /*@ngInject*/
    constructor(private registrationService: RegistrationService,
                private userService: UserService,
                private currentAuth: Auth) {
    }

    public init(closeDialogFunction: () => any): void {
        this.closeDialogFunction = closeDialogFunction;
    }

    public async activateUser() {
        await this.userService.activateUser(this.currentAuth.activeUser);
        this.closeDialogFunction();
    }
}
